import { AccountType } from '@scrambl/shared'

import { useOrganizationStore } from '@/store/organization.store'

/**
 * Shell-selection variant of `useAccountType`.
 *
 * `useAccountType` fails safe to ORGANIZATION while the org store is empty,
 * which is right for feature gates but wrong for choosing the layout shell: a
 * personal user would see the work sidebar flash on every cold boot. Until the
 * store resolves, fall back to the `data-account-type` attribute that
 * `initPersonalThemeAttribute()` stamps synchronously from the cross-window
 * cache before first render — the same seam the warm-hearth theme uses.
 */
export function useIsPersonalSpace(): boolean {
  const currentOrganization = useOrganizationStore(
    state => state.currentOrganization,
  )
  if (currentOrganization) {
    return currentOrganization.accountType === AccountType.PERSONAL
  }
  if (typeof document === 'undefined') return false
  return (
    document.documentElement.getAttribute('data-account-type') === 'personal'
  )
}
